import { AbstractControl, ValidationErrors, FormGroup, ValidatorFn } from '@angular/forms';

export function classRankLessThanClassSizeValidator(group: FormGroup): ValidationErrors | null {
  const classRank = group.get('classRank')?.value;
  const classSize = group.get('classSize')?.value;

  if (
    (classRank === null || classRank === undefined || classRank === 0) &&
    (classSize === null || classSize === undefined || classSize === 0)
  ) {
    return null;
  }

  const bothNumbers =
    classRank != null &&
    classSize != null &&
    !isNaN(classRank) &&
    !isNaN(classSize);

  if(bothNumbers){
    // Check if both values exist and classRank is greater than or equal to classSize
    if (classRank >= classSize && classSize > 0) {
      return { classRankLessThanClassSize: 'Class Rank must be less than Class Size' };
    }
    if(classSize === 0 && classRank > 0){
      return { classSizeIsZero: 'Class Size cannot be zero if Class Rank is greater than zero' };
    }
    if(classRank === 0 && classSize > 0){
      return { classRankIsZero: 'Class Rank cannot be zero if Class Size is greater than zero' };
    }
  }
  return null; // no error
}

export function undergraduateClassRankLessThanClassSizeValidator(group: FormGroup): ValidationErrors | null {
  const classRank = group.get('UnderGraduateClassRank')?.value;
  const classSize = group.get('UnderGraduateClassSize')?.value;

  if (
    (classRank === null || classRank === undefined || classRank === 0) &&
    (classSize === null || classSize === undefined || classSize === 0)
  ) {
    return null;
  }

  const bothNumbers =
    classRank != null &&
    classSize != null &&
    !isNaN(classRank) &&
    !isNaN(classSize);

  if(bothNumbers){
    // Check if both values exist and classRank is greater than or equal to classSize
    if (classRank >= classSize && classSize > 0) {
      return { undergraduateClassRankLessThanClassSize: 'Class Rank must be less than Class Size' };
    }
    if(classSize === 0 && classRank > 0){
      return { classSizeIsZero: 'Class Size cannot be zero if Class Rank is greater than zero' };
    }
    if(classRank === 0 && classSize > 0){
      return { classRankIsZero: 'Class Rank cannot be zero if Class Size is greater than zero' };
    }
  }
 
  return null; // no error
}


export function graduateClassRankLessThanClassSizeValidator(group: FormGroup): ValidationErrors | null {
  const classRank = group.get('GraduateClassRank')?.value;
  const classSize = group.get('GraduateClassSize')?.value;

  if (
    (classRank === null || classRank === undefined || classRank === 0) &&
    (classSize === null || classSize === undefined || classSize === 0)
  ) {
    return null;
  }

  const bothNumbers =
    classRank != null &&
    classSize != null &&
    !isNaN(classRank) &&
    !isNaN(classSize);

  if(bothNumbers){
    // Check if both values exist and classRank is greater than or equal to classSize
    if (classRank >= classSize && classSize > 0) {
      return { graduateClassRankLessThanClassSize: 'Class Rank must be less than Class Size' };
    }
    if(classSize === 0 && classRank > 0){
      return { classSizeIsZero: 'Class Size cannot be zero if Class Rank is greater than zero' };
    }
    if(classRank === 0 && classSize > 0){
      return { classRankIsZero: 'Class Rank cannot be zero if Class Size is greater than zero' };
    }
  }
  return null; // no error
}



